export default {
  "site.name": "久久插",
  "site.tagline": "持久稳固的插接解决方案",
  "site.description": "久久插，专为追求持久稳固插接效果的用户打造。",
  "nav.home": "首页",
  "nav.products": "产品中心",
  "nav.articles": "技术资讯",
  "nav.about": "关于我们",
  "nav.contact": "联系我们",
  "hero.title": "持久稳固，连接无忧",
  "hero.subtitle": "久久插——专为追求持久稳固插接效果的用户打造。无论工业连接、家用装配还是专业施工，久久插凭借卓越工艺与可靠材质，提供经久耐用的插接体验。",
  "hero.cta": "查看产品",
  "hero.secondary": "了解更多",
  "categories.title": "产品分类",
  "categories.subtitle": "六大产品系列，覆盖全场景插接需求",
  "categories.viewAll": "查看全部",
  "products.featured": "热门产品",
  "products.featured.subtitle": "经过市场验证的久久插明星产品",
  "products.viewDetail": "查看详情",
  "products.price": "价格",
  "advantages.title": "为什么选择久久插",
  "advantages.subtitle": "六大核心优势，铸就持久稳固的插接品质",
  "advantages.quality": "卓越品质",
  "advantages.quality.desc": "ISO 9001 认证，全流程品质管控",
  "advantages.durability": "持久耐用",
  "advantages.durability.desc": "5000-10000 次插拔寿命，10 年+ 使用周期",
  "advantages.protection": "全面防护",
  "advantages.protection.desc": "IP68 防水防尘，-40°C 至 125°C 耐温",
  "advantages.custom": "按需定制",
  "advantages.custom.desc": "从设计到量产，一站式定制服务",
  "advantages.safety": "安全可靠",
  "advantages.safety.desc": "CCC/CE/UL 多重认证，安全无忧",
  "advantages.support": "专业支持",
  "advantages.support.desc": "7×24 小时技术支持，2-5 年质保",
  "articles.latest": "最新技术资讯",
  "articles.latest.subtitle": "久久插技术团队分享行业洞见与实用指南",
  "articles.readMore": "阅读全文",
  "articles.viewAll": "查看所有文章",
  "faq.title": "常见问题",
  "faq.subtitle": "关于久久插产品与服务的常见疑问解答",
  "cta.title": "寻找适合您的插接解决方案",
  "cta.subtitle": "无论是标准产品还是定制方案，久久插专业团队随时为您服务",
  "cta.button": "立即咨询",
  "footer.copyright": "© 2026 久久插。保留所有权利。",
  "footer.products": "产品",
  "footer.company": "公司",
  "footer.support": "支持",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "category.all": "全部",
  "category.products": "个产品",
  "breadcrumb.home": "首页",
  "about.title": "关于久久插",
  "about.story": "品牌故事",
  "about.story.content": "久久插成立于 2008 年，十八年来始终专注于插接技术的研发与创新。从最初的工业连接器起步，久久插逐步拓展至家用装配、专业施工、精密仪器等领域，成为国内领先的持久插接解决方案提供商。\n\n久久插的品牌理念源自对「连接」二字的深刻理解——连接不仅仅是电气导通，更是安全、可靠与持久。每一件久久插产品都承载着对品质的执着追求。\n\n截至目前，久久插已服务超过 10,000 家企业客户，产品远销 30 多个国家和地区，在新能源、智能制造、轨道交通等领域建立了卓越口碑。",
  "about.values": "品牌信誉",
  "about.values.cert": "权威认证",
  "about.values.cert.desc": "CCC、CE、UL、ISO 9001 等多项国内外认证",
  "about.values.clients": "服务客户",
  "about.values.clients.desc": "累计服务 10,000+ 企业客户",
  "about.values.years": "行业经验",
  "about.values.years.desc": "18 年插接技术研发与制造经验",
  "about.values.patents": "技术专利",
  "about.values.patents.desc": "拥有 50+ 项国家专利技术",
  "about.contact": "联系我们",
  "about.contact.address": "公司地址",
  "about.contact.phone": "联系电话",
  "about.contact.email": "电子邮箱",
  "about.contact.hours": "工作时间",
  "about.contact.form": "在线留言",
  "about.contact.name": "姓名",
  "about.contact.name.placeholder": "请输入您的姓名",
  "about.contact.email.placeholder": "请输入您的电子邮箱",
  "about.contact.phone.placeholder": "请输入您的联系电话",
  "about.contact.message": "留言内容",
  "about.contact.message.placeholder": "请输入您想咨询的内容（限 500 字）",
  "about.contact.submit": "提交留言",
  "about.contact.success": "留言提交成功！我们将尽快与您联系。",
  "about.contact.error": "提交失败，请稍后重试。",
  "articles.page.title": "技术资讯",
  "articles.page.subtitle": "久久插技术团队分享行业洞见、选购指南与应用实践",
  "articles.search.placeholder": "搜索文章...",
  "articles.noResults": "未找到相关文章",
};